import { useDispatch, useSelector } from 'react-redux';
import { useEffectOnce } from 'usehooks-ts';

import { useParseParams } from '@hooks/params';
import { findHealthQuoteParamsSchema } from '@apis/HealthQuoteApi';

import { selectHealthQuoteDetailsPage } from './selector';
import { healthQuoteFind, HealthQuoteFindPayload } from './action';
import { HealthQuoteDetailsPageParams } from './route';

export const useHealthQuoteDetailsPageParams = () =>
  useParseParams<HealthQuoteDetailsPageParams>(findHealthQuoteParamsSchema);

export const useHealthQuoteFind = () => {
  const dispatch = useDispatch();
  const params = useHealthQuoteDetailsPageParams();
  const { healthQuote } = useSelector(selectHealthQuoteDetailsPage);

  useEffectOnce(() => {
    const payload: HealthQuoteFindPayload = params;
    dispatch(healthQuoteFind(payload));
  });

  return healthQuote;
};
